import * as React from 'react';
export type IDropzoneContext = {
  translations: {
    dropFilesMessage: string;
    dropFilesDescription?: string;
  };
};

export const DropzoneContext = React.createContext<
  IDropzoneContext | undefined
>(undefined);

export const useDropzoneContext = () => {
  const context = React.useContext(DropzoneContext);

  if (context === undefined) {
    throw new Error('useDropzoneContext not used inside the DT context');
  }

  return context;
};
